(() => {
  const mediaUrl = (row) => {
    const sku = row?.dataset?.variantSku || '';
    const match = sku.match(/^P-([0-9]+)-(BLK|GLE|GLR|GLQ|BOX|CCS|ZIP|CCL)$/);
    if (!match) return '';
    const [, article, format] = match;
    if (format === 'BLK') return '/cdn/shop/files/P-' + article + '-BLK-Aperigusto.jpg';
    const suffix = ['GLE', 'GLR', 'GLQ'].includes(format) ? '-zoom_black.png' : '-zoom.png';
    return '/cdn/shop/files/' + article + '-' + format + suffix;
  };
  const sync = (row) => {
    const src = mediaUrl(row);
    if (!src) return;
    const sku = row?.dataset?.variantSku || '';
    const gallery = document.querySelector('media-gallery');
    const images = Array.from(gallery?.querySelectorAll('img') || []).filter((image) =>
      image.alt?.includes(sku) || (image.offsetWidth > 0 && image.offsetHeight > 0));
    const sticky = document.querySelector('img[data-testid="sticky-product-image"]');
    if (sticky && !images.includes(sticky)) images.push(sticky);
    if (!images.length) return;
    const absolute = new URL(src, location.origin).href;
    images.forEach((image) => {
      image.src = absolute;
      image.srcset = absolute + ' 1600w';
      image.setAttribute('data_max_resolution', absolute);
      image.closest('picture')?.querySelectorAll('source').forEach((source) => {
        source.srcset = absolute + ' 1600w';
      });
    });
  };
  const current = () =>
    document.querySelector('.envp__row.is-cur[data-variant-sku]') ||
    document.querySelector('.envp__row[data-variant-sku]');
  const resync = (row) => [0, 120, 500, 1200].forEach((delay) =>
    window.setTimeout(() => sync(row || current()), delay));
  document.addEventListener('click', (event) => {
    const row = event.target.closest?.('.envp__row[data-variant-sku]');
    if (row) resync(row);
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => resync(current()), { once: true });
  } else {
    resync(current());
  }
  document.addEventListener('shopify:section:load', () => resync(current()));
})();